/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { absDependencies } from './dependenciesAbs.generated.js';
import { addDependencies } from './dependenciesAdd.generated.js';
import { identityDependencies } from './dependenciesIdentity.generated.js';
import { invDependencies } from './dependenciesInv.generated.js';
import { mapDependencies } from './dependenciesMap.generated.js';
import { maxDependencies } from './dependenciesMax.generated.js';
import { multiplyDependencies } from './dependenciesMultiply.generated.js';
import { sizeDependencies } from './dependenciesSize.generated.js';
import { sqrtDependencies } from './dependenciesSqrt.generated.js';
import { subtractDependencies } from './dependenciesSubtract.generated.js';
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createSqrtm } from '../../factoriesAny.js';
export var sqrtmDependencies = {
  absDependencies,
  addDependencies,
  identityDependencies,
  invDependencies,
  mapDependencies,
  maxDependencies,
  multiplyDependencies,
  sizeDependencies,
  sqrtDependencies,
  subtractDependencies,
  typedDependencies,
  createSqrtm
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesSqrtm.generated.js
// module id = h8X+
// module chunks = 3